"use strict";
export const migration25 = (state) => {
  if (!state) {
    return void 0;
  }
  if (!state.user) {
    return { ...state, _persist: { ...state._persist, version: 25 } };
  }
  return {
    ...state,
    user: { ...state.user, tokens: state.user.tokens ?? {} },
    _persist: { ...state._persist, version: 25 }
  };
};
